module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70017/img/landing-page-zero.png"